import React from "react";

// "Reset to default" icon — two curved arrows (refresh-cw). Shared across
// every reset button (rubric, section and image-table resets). Stroke-based,
// so color comes from `stroke: currentColor` (the parent button's `color`);
// do NOT pass `fill: currentColor` or the outline glyph fills in solid.
export const ResetIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
        {...props}
    >
        <path d="M1 4v6h6M23 20v-6h-6" />
        <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" />
    </svg>
);
